export const DEFAULT_MESSAGE = "Cargando...";
export const INIT_LOADING_REQUEST = {
    hidden: true,
    message: DEFAULT_MESSAGE
};